import React from "react"

import CurrencyInput from "react-currency-input-field"

export default function DimensionInput(props) {
  return (
    <CurrencyInput
      className="form-control dimension-input"
      style={{ height: 33 }}
      allowDecimals={true}
      decimalsLimit={1}
      // decimalScale={1}
      allowNegativeValue={true}
      {...props}
    />
  )
}
